module.exports = __webpack_public_path__ + "media/triangle.55f66c9e.mp4";